import React from 'react';

export default function FwPlusIcon({ color = 'currentColor', fontSize = '16px' }) {
  return (
    <>
      <i className='fas fa-plus-circle' style={{ color, fontSize: fontSize }}></i>
    </>
  );
}